import React, {memo, ReactElement} from "react";
import {Props} from "./PeopleCard.types";
import {CompareModule} from "modules/Compare.module";
import {Flex, FlexItem, Text} from "@fluentui/react-northstar";
import "./PeopleCard.styles.scss";
import moment from "moment";

export const PeopleCard = memo((props: Props): ReactElement | null => {
    const {id, date, userMail} = props.item;
    return (
        <Flex key={id} className={"people-card"} fill hAlign={"start"} vAlign={"center"} gap={"gap.small"}>
            <Flex fill gap={"gap.small"} vAlign={"center"}>
                <Text truncated title={userMail} content={userMail}/>
                {date &&
                    <FlexItem push>
                        <Text className={"no-shrink"} styles={{color: "darkgray"}}
                              content={moment(date).format("LLL")}/>
                    </FlexItem>
                }
            </Flex>
        </Flex>
    )
}, CompareModule.areObjectsEqual);